import { render, staticRenderFns } from "./TodoHeader.vue?vue&type=template&id=620e8a16&scoped=true&"
import script from "./TodoHeader.vue?vue&type=script&lang=js&"
export * from "./TodoHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "620e8a16",
  null
  
)

export default component.exports